<template>
    <ValidationObserver ref="formValid">
        <form @change="sendDataForSaving">
            <div class="row">

                <ValidationProvider
                    name="Position"
                    rules="required"
                    v-slot="{ errors }"
                    class="col-md-6 "
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Position Applying</label>
                        <select
                            class="custom-select"
                            v-model="form.position_applying"
                        >
                            <option
                                v-for="position in positions"
                                :value="position.id"
                            >
                                {{ position.title }}
                            </option>
                        </select>
                        <FormError :error="errors[0]" name="Position"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    name="Rate of pay"
                    rules="required|customNumeric"
                    v-slot="{ errors }"
                    class="col-md-6"
                >
                    <div
                        class="form-group form-group-1"
                        v-show="viewRates"
                    >
                        <label for="" class="form-label">Rate of pay desired</label>
                        <input type="text" class="form-control" v-model="form.rate_of_pay">

                        <FormError :error="errors[0]" name="Rate of pay"></FormError>
                    </div>
                </ValidationProvider>

                <div class="col-md-12">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">I have the following security license</label>
                        <div class="form-group form-group-1">
                            <VueMultiSelect
                                :options="licensesTypes"
                                :selected_options="selectedLicenses"
                                v-model="selectedLicenses"
                            ></VueMultiSelect>
                        </div>
                    </div>
                </div>

                <LicenseInput
                    v-for="license in filledLicenses"
                    :key="license.type"
                    :license.sync="license"
                    v-show="isActiveLicense(license)"
                ></LicenseInput>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>

import LicenseInput from "./LicenseInput.vue";
import VueMultiSelect from "../../../../../../resources/js/plugins/VueMultiSelect.vue";

export default {
    name: 'PositionApplying',
    components: {
        VueMultiSelect,
        LicenseInput,
    },
    emits: ['data-changed'],
    props: {
        user: {
            type: Object
        },
        positions: {
            type: Array
        },
        licensesList: {
            type: Array
        },
        viewRates: Boolean,
    },
    data() {
        return {
            form: {
                position_applying: null,
                rate_of_pay: null,
                licenses: []
            },
            licensesTypes: [],
            filledLicenses: [],
            selectedLicenses: [],
        }
    },
    methods: {
        addLicenseDetails() {
            this.licensesList.forEach(({type, id, ...rest}) => {
                this.filledLicenses.push({
                    license_id: id,
                    type: type,
                    number: null,
                    expiration_date: null,
                    school_received: null,
                    experience: null,
                    show: {
                        ...rest
                    }
                });
            })
        },
        deleteFlags() {
            this.form.licenses = this.filledLicenses.map(({show, ...license}) => license);
        },
        getLicensesType() {
            this.licensesTypes = this.licensesList.map(({type}) => type);
        },
        isActiveLicense(license) {
            return this.selectedLicenses.includes(license.type)
        },
        sendDataForSaving() {
            this.deleteFlags()
            const {licenses} = this.form;
            const payloadData = {
                ...this.form,
                licenses: licenses.filter((license) => this.selectedLicenses.includes(license.type))
            }
            this.$emit('data-changed', payloadData);
        },
        setUserData() {
            this.form.position_applying = this.user.position_applying_id;
            this.form.rate_of_pay = this.user.rate_of_pay;

            this.selectedLicenses = this.user.licenses.map(obj => obj.license_type);


            const restructuredArray = this.user.licenses.map(item => ({
                experience: item.experience,
                expiration_date: item.expiration_date,
                license_id: item.license_id,
                type: item.license_type,
                number: item.number,
                school_received: item.school_received,
                show: {
                    has_experience: item.license.has_experience,
                    has_expiration_date: item.license.has_expiration_date,
                    has_number: item.license.has_number,
                    has_school_received: item.license.has_school_received
                }
            }));

            this.filledLicenses = this.filledLicenses.filter(license => {
                return !restructuredArray.some(newLicense => newLicense.type === license.type);
            });

            if (this.user.licenses.length > 0) {
                this.filledLicenses = [
                    ...this.filledLicenses,
                    ...restructuredArray
                ];
            }
        },
    },
    mounted() {
        this.addLicenseDetails();
        this.getLicensesType();
        this.setUserData();
    },
    updated() {
        this.sendDataForSaving()
    },
}

</script>

<style scoped>

</style>
